module.exports = __webpack_public_path__ + "71d9c500b4053d0e8d4d85ed9e8d8ed0.png";